export const LISTS_PATH = '/lists'

export const listPath = id => `${LISTS_PATH}/${id}`

export const OVERVIEW_TAB = { name: 'Overview', id: 'overview' }
export const TIER_LISTS_TAB = { name: 'Membership tier lists', id: 'membership' }
export const SMART_LISTS_TAB = { name: 'Smart lists', id: 'smart' }

export function listSections(isCatering) {
  return [OVERVIEW_TAB, ...(isCatering ? [] : [TIER_LISTS_TAB]), SMART_LISTS_TAB]
}

const newestFirst = (a, b) => new Date(b.attributes.updated_at) - new Date(a.attributes.updated_at)

export const rootLists = (audiences = []) =>
  audiences.filter(audience => audience.attributes.is_root && !audience.attributes.date).sort(newestFirst)

export const isTierList = audience => Boolean(audience.relationships?.membership_tier)
